import { cn } from "./cn";
const base = "inline-flex items-center justify-center gap-2 font-display font-medium rounded-pill transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal focus-visible:ring-offset-2 focus-visible:ring-offset-paper dark:focus-visible:ring-offset-ink disabled:opacity-50 disabled:pointer-events-none";
const variants = {
    primary: "bg-signal text-white hover:bg-signal-bright shadow-signal hover:-translate-y-0.5",
    outline: "border border-ink/15 dark:border-paper/20 text-ink dark:text-paper hover:border-signal hover:text-signal dark:hover:text-signal-bright",
    ghost: "text-ink dark:text-paper hover:text-signal dark:hover:text-signal-bright",
};
const sizes = {
    md: "h-11 px-5 text-sm",
    lg: "h-13 px-7 text-base",
};
/**
 * Build ComOS button classes for any element — use on a react-router <Link>:
 *   <Link to="/register" className={buttonStyles({ variant: "primary", size: "lg" })}>
 */
export function buttonStyles(opts) {
    const { variant = "primary", size = "md", className } = opts ?? {};
    return cn(base, variants[variant], sizes[size], className);
}
